export default "__VITE_ASSET__6b80fe4b__"